import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft, Shield } from 'lucide-react';

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-primary-100 rounded-full mb-6">
            <Shield className="w-10 h-10 text-primary-600" aria-hidden="true" />
          </div>
          
          <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">Page Not Found</h2>
          <p className="text-lg text-gray-600 mb-8 max-w-md mx-auto">
            The secure page you're looking for doesn't exist or may have been moved.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center space-x-2 bg-primary-600 text-white font-semibold px-6 py-3 rounded-lg hover:bg-primary-700 transition-colors duration-200 focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
            >
              <Home className="w-5 h-5" aria-hidden="true" />
              <span>Go Home</span>
            </Link>
            
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center justify-center space-x-2 bg-gray-200 text-gray-900 font-semibold px-6 py-3 rounded-lg hover:bg-gray-300 transition-colors duration-200 focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
            >
              <ArrowLeft className="w-5 h-5" aria-hidden="true" />
              <span>Go Back</span>
            </button>
          </div>
          
          <div className="mt-12 text-sm text-gray-500">
            <p>Need help? Our secure file transfer system is designed to keep your data safe.</p>
            <div className="flex items-center justify-center space-x-4 mt-4">
              <div className="flex items-center space-x-1">
                <Shield className="w-4 h-4 text-security-500" aria-hidden="true" />
                <span>Encrypted</span>
              </div>
              <div className="flex items-center space-x-1">
                <Shield className="w-4 h-4 text-security-500" aria-hidden="true" />
                <span>Secure</span>
              </div>
              <div className="flex items-center space-x-1">
                <Shield className="w-4 h-4 text-security-500" aria-hidden="true" />
                <span>Private</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}